module.exports = __webpack_public_path__ + "static/media/dark-motion-deorbiting.2742ba1.mp4";